import React from "react";
import "../styles/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h2>Privacy Policy</h2>
      <p>
        At Smart Water Management, we respect and protect your privacy. This
        Privacy Policy outlines how we collect, use, and safeguard your personal
        information.
      </p>
      <h3>1. Information We Collect</h3>
      <p>
        We collect information such as your name, contact details, and feedback
        when you interact with our app. This information helps us improve your
        experience.
      </p>
      <h3>2. How We Use Your Information</h3>
      <p>
        We use your data to enhance our services, send updates, and respond to
        your feedback. We do not share your data with third parties without
        your consent.
      </p>
      <h3>3. Data Security</h3>
      <p>
        We implement robust security measures to protect your personal
        information. However, no method of transmission over the internet is
        100% secure.
      </p>
      <h3>4. Your Rights</h3>
      <p>
        You have the right to access, modify, or delete your personal data.
        For any requests, please contact us directly.
      </p>
      <h3>5. Changes to This Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. Any changes will
        be posted on this page.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
